var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RealTimeMap',{attrs:{"processionId":_vm.processionId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }